import React, { useEffect } from "react";
//import TimeLine from "react-gantt-timeline";
import AuthStore from "../../../Auth/AuthStore";
import MainStore from "../../../../MainStore";
import Button from "@mui/material/Button";
import ButtonGroup from '@mui/material/ButtonGroup';

const config = {
    header: { //Targert the time header containing the information month/day of the week, day and time.
        top: {//Tartget the month elements
            style: { backgroundColor: "#333333" } //The style applied to the month elements
        },
        middle: {//Tartget elements displaying the day of week info
            style: { backgroundColor: "chocolate" }, //The style applied to the day of week elements
            selectedStyle: { backgroundColor: "#b13525" }//The style applied to the day of week elements when is selected
        },
        bottom: {//Tartget elements displaying the day number or time 
            style: { background: "grey", fontSize: 9 },//the style tp be applied 
            selectedStyle: { backgroundColor: "#b13525", fontWeight: 'bold' }//the style tp be applied  when selected
        }
    },
    taskList: {//the right side task list
        title: {//The title od the task list
            label: "Задачи",//The caption to display as title
            style: {
                backgroundColor: '#333333', borderBottom: 'solid 1px silver',
                color: 'white', textAlign: 'center'
            }//The style to be applied to the title
        },
        task: {// The items inside the list diplaying the task
            style: { backgroundColor: '#fbf9f9' }// the style to be applied
        },
        verticalSeparator: {//the vertical seperator use to resize he width of the task list
            style: { backgroundColor: '#333333', },//the style
            grip: {//the four square grip inside the vertical separator
                style: { backgroundColor: '#cfcfcd' }//the style to be applied
            }
        }
    },
    dataViewPort: {//The are where we display the task
        rows: {//the row constainting a task
            style: { backgroundColor: "#fbf9f9", borderBottom: 'solid 0.5px #cfcfcd' }
        },
        task: {
            showLabel: false,//If the task display the a lable
            style: {
                position: 'absolute', borderRadius: 14, color: 'white',
                textAlign: 'center', backgroundColor: 'grey'
            },
            selectedStyle: {}//the style tp be applied  when selected
        }
    },
    links: {//The link between two task
        color: 'black',
        selectedColor: '#ff00fa'
    }
}

export default class ProjectCalendar extends React.PureComponent {
    constructor(props) {
        super(props);
        var url = new URL(document.location.href);
        var projectId = url.searchParams.get("projectId");
        this.state = { data: [], links: [], selectedItem: null, projectId: projectId, mode: "month" };
        this.loadTasks();

        this.convertTask = this.convertTask.bind(this);
        this.changeMode = this.changeMode.bind(this);
    }

    loadTasks() {
        var token = localStorage.getItem("token");
        var scope = this;
        MainStore.setMaskVisible();
        fetch('api/Project/GetProjectStages?id=' + encodeURIComponent(this.state.projectId), {
            method: 'GET',
            headers: {
                'Authorization': 'Bearer ' + token
            },
            body: null,
        }).then(function (res) {
            if (res.status === 401) {
                AuthStore.openLogin();
                MainStore.setMaskUnvisible();
            }
            else {
                res.json().then((result) => {
                    MainStore.setMaskUnvisible();
                    scope.setState({ data: scope.convertTasks(result)});
                }).catch((err) => console.log(err));
            }
        });
    }

    genID() {
        function S4() {
            return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
        }
        return (
            S4() +
            S4() +
            "-" +
            S4() +
            "-4" +
            S4().substr(0, 3) +
            "-" +
            S4() +
            "-" +
            S4() +
            S4() +
            S4()
        ).toLowerCase();
    }

    getRandomDate() {
        let result = new Date();
        result.setDate(result.getDate() + Math.random() * 10);
        return result;
    }
    getRandomColor() {
        var letters = "0123456789ABCDEF";
        var color = "#";
        for (var i = 0; i < 6; i++) {
            color += letters[Math.floor(Math.random() * 16)];
        }
        return color;
    }

    createLink(start, end) {
        return {
            id: this.genID(),
            start: start.task.id,
            end: end.task.id
        };
    }
    onUpdateTask = (item, props) => {
        item.start = props.start ? props.start : item.start;
        item.end = props.end ? props.end : item.end;
        item.end = item.end;
        item.start = item.start;
        item.name = props.name ? props.name : item.name;
        item.projectId = this.state.projectId;

        var token = localStorage.getItem("token");
        var scope = this;

        MainStore.setMaskVisible();
        fetch('api/Project/SaveProjectTimeLine', {
            method: 'POST',
            body: JSON.stringify(item),
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + token
            }
        }).then(function (res) {
            if (res.status === 401) {
                AuthStore.openLogin();
                MainStore.setMaskUnvisible();
            }
            else {
                res.json().then((result) => {
                    MainStore.setMaskUnvisible();
                    scope.setState({ data: [...scope.state.data] });
                }).catch((err) => console.log(err));
            }
        });

    };
    onCreateLink = item => {
        /*let newLink = this.createLink(item.start, item.end);
        this.setState({
            links: [...this.state.links, newLink],
            selectedItem: newLink
        });*/
    };
    onSelectItem = item => {
        console.log(`Select Item ${item}`);
        this.setState({ selectedItem: item });
    };

    convertTask(task) {
        task.start = new Date(task.start);
        task.end = new Date(task.end);
        task.color = this.getRandomColor();
        return task;
    }

    convertTasks(tasks) {
        tasks.forEach(t => t = this.convertTask(t))
        return tasks;
    }

    addTask = () => {
        var token = localStorage.getItem("token");
        var scope = this;
        
        MainStore.setMaskVisible();
        fetch('api/Project/SaveProjectTimeLine', {
            method: 'POST',
            body: JSON.stringify({ name: "New task", projectId: this.state.projectId }),
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + token
            }
        }).then(function (res) {
            if (res.status === 401) {
                AuthStore.openLogin();
                MainStore.setMaskUnvisible();
            }
            else {
                res.json().then((result) => {
                    MainStore.setMaskUnvisible();
                    result.color = scope.getRandomColor();
                    scope.setState({ data: [scope.convertTask(result), ...scope.state.data] });
                }).catch((err) => console.log(err));
            }
        });
    };

    delete = () => {
        var token = localStorage.getItem("token");
        var scope = this;

        MainStore.setMaskVisible();
        fetch('api/Project/DeleteProjectTimeLine', {
            method: 'POST',
            body: JSON.stringify(scope.state.selectedItem),
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + token
            }
        }).then(function (res) {
            if (res.status === 401) {
                AuthStore.openLogin();
                MainStore.setMaskUnvisible();
            }
            else {
                res.json().then((result) => {
                    MainStore.setMaskUnvisible();
                    //scope.setState({ data: [scope.convertTask(result), ...scope.state.data] });

                    if (scope.state.selectedItem) {
                        let index = scope.state.links.indexOf(scope.state.selectedItem);
                        if (index > -1) {
                            scope.state.links.splice(index, 1);
                            scope.setState({ links: [...scope.state.links] });
                        }
                        index = scope.state.data.indexOf(scope.state.selectedItem);
                        if (index > -1) {
                            scope.state.data.splice(index, 1);
                            scope.setState({ data: [...scope.state.data] });
                        }
                    }
                }).catch((err) => console.log(err));
            }
        });
    };

    changeMode = mode => () => {
        this.setState({mode: mode});
    }
    
    render() {
        return (
            <div>
                <div className="mode-button" onClick={this.addTask}>
                    <svg height={30} width={30} viewBox="0 0 48 48">
                        <path
                            fill="silver"
                            d="M24 4C12.95 4 4 12.95 4 24s8.95 20 20 20 20-8.95 20-20S35.05 4 24 4zm10 22h-8v8h-4v-8h-8v-4h8v-8h4v8h8v4z"
                        />
                    </svg>
                </div>
                <div className="mode-button" onClick={this.delete}>
                    <svg height={30} width={30} viewBox="0 0 48 48">
                        <path
                            fill="silver"
                            d="M24 4C12.95 4 4 12.95 4 24s8.95 20 20 20 20-8.95 20-20S35.05 4 24 4zm10 22H14v-4h20v4z"
                        />
                    </svg>
                </div>
                <ButtonGroup color="primary" aria-label="outlined primary button group">
                    <Button color={this.state.mode === "day" ? "secondary" : "primary"} onClick={this.changeMode("day")}>День</Button>
                    <Button color={this.state.mode === "week" ? "secondary" : "primary"} onClick={this.changeMode("week")}>Неделя</Button>
                    <Button color={this.state.mode === "month" ? "secondary" : "primary"} onClick={this.changeMode("month")}>Месяц</Button>
                    <Button color={this.state.mode === "year" ? "secondary" : "primary"} onClick={this.changeMode("year")}>Год</Button>
                </ButtonGroup>
                {/*<TimeLine*/}
                {/*    config={config}*/}
                {/*    mode={this.state.mode}*/}
                {/*    data={this.state.data}*/}
                {/*    links={this.state.links}*/}
                {/*    onUpdateTask={this.onUpdateTask}*/}
                {/*    //onCreateLink={this.onCreateLink}*/}
                {/*    onSelectItem={this.onSelectItem}*/}
                {/*    selectedItem={this.state.selectedItem}*/}
                {/*/>*/}
            </div>
        )
    }
}
